import { FC } from 'react';
import { Button, Icon, ButtonProps, Tooltip, useBreakpointValue } from '@chakra-ui/react';

export type ListActionButtonProps = Omit<ButtonProps, 'aria-label'> & {
  label: string;
  icon?: React.ReactElement;
  variant?: 'ghost' | 'outline' | 'solid' | 'link' | 'unstyled' | 'emphasis';
  iconType?: React.ElementType;
  hideLabel?: boolean;
};

export const ListActionButton: FC<ListActionButtonProps> = ({ icon, variant = 'ghost', iconType, label, ...rest }) => {
  const isTooltipDisabled = useBreakpointValue({ base: false, lg: true });
  return (
    <Tooltip label={label} hasArrow placement="top" isDisabled={isTooltipDisabled}>
      <Button
        leftIcon={iconType ? <Icon as={iconType} /> : icon}
        variant={variant}
        colorScheme="neutral"
        aria-label={label}
        size="sm"
        {...rest}
      >
        {label}
      </Button>
    </Tooltip>
  );
};
